import React from 'react';
import { AsLink } from '@components/atoms/AsLink';
import ArrowRightIcon from '@components/atoms/icons/ArrowRightIcon';

export const ExternalButton = ({
  url,
  target,
  title,
  descendants,
  isOpen = false
}) => {
  return (
    <AsLink
      w="100%"
      m="4"
      ml="2"
      py="5"
      url={url}
      color="secondary.light-grey"
      background="primary.dark-blue"
      cursor="pointer"
      role="menuitem"
      pointerEvents="auto"
      isExternal
      rightIcon={<ArrowRightIcon color="primary.froneri-blue" h="6" w="6" />}
      target={target}
      opacity={isOpen ? `1` : `0`}
      transition={`opacity 0.05s ease-in ${descendants.length * 0.05}s`}
      _hover={{
        background: `secondary.pink`,
        svg: {
          fill: `secondary.light-grey`
        }
      }}>
      {title}
    </AsLink>
  );
};

export default ExternalButton;
